// import { DepartmentsList } from "components/Departments";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { WSIBOntarioCodeSetup } from "../../components/WSIBOntarioCodeSetup";

export interface IWSIBOntarioCodeSetupPage { }

export const WSIBOntarioCodeSetupPage: FC<IWSIBOntarioCodeSetupPage> = (
  props: IWSIBOntarioCodeSetupPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Ontario Code Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Code Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBOntarioCodeSetup />}
    />
  );
};
